import React from "react";
import { Modal, Stack, Button, ButtonGroup, Text } from "@chaser/components";

const CancelSubscriptionModal = ({ open, close, onClosed }) => {
  const openCancellationRequest = () => {
    window.open(
      "https://www.chaserhq.com/cancellation-request",
      "_blank",
      "noopener,noreferrer",
    );
  };

  return (
    <Modal
      title="Cancel your subscription"
      open={open}
      toggle={close}
      onClosed={onClosed}
    >
      <Modal.Body>
        <Stack gap="medium">
          <Stack gap="small" pt="xsmall">
            <Text>
              To cancel your subscription, please submit a cancellation request.
            </Text>
            <Text color="Mid Neutral 1">
              The form opens in a new tab and should only take a minute to
              complete.
            </Text>
          </Stack>
        </Stack>
      </Modal.Body>
      <Modal.Footer>
        <ButtonGroup>
          <Button
            appearance="primary"
            size="narrow"
            onClick={openCancellationRequest}
          >
            Open cancellation request
          </Button>
          <Button appearance="secondary" size="narrow" onClick={close}>
            Keep subscription
          </Button>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  );
};

export default CancelSubscriptionModal;
